var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"btn btn-outline-primary buttons potomac-btn",attrs:{"target":"_blank","type":"button","variant":"link","href":"https://apply.jobappnetwork.com/potomac-family-dining"}},[_vm._v(" APPLY ONLINE ")])}
var staticRenderFns = []

export { render, staticRenderFns }